import { getUserAccessToken, removeToken } from "@/utils/auth";
import api from "@/api/common";
const state = {
  loginUserInfo: {},
  loginUser: {},
};

// 把数据导出时可以对数据做一些操作 但不会改变原数据
const getters = {
  loginUserInfo: (state) => state.loginUserInfo,
  loginUser: (state) => state.loginUser,
};

// 使用 mutation更新 state
const mutations = {
  LOGIN_USER_INFO: (state, data) => {
    state.loginUserInfo = data;
  },
  LOGIN_USER: (state, data) => {
    state.loginUser = data;
  },
};


const actions = {
  // 把 commit属性从 context里面解构出来
  loginUserInfo: async ({ commit }, data) => {
    if(data) {
      commit('LOGIN_USER_INFO', data.partnerUser)
      commit('LOGIN_USER', data.user)
      return
    }
    const token = getUserAccessToken() || ''
    if(token) {
      await api.userInfo().then(async (res) => {
        if(res.code == 0) {
          commit('LOGIN_USER_INFO', res.data.partnerUser)
          commit('LOGIN_USER', res.data.user)
        }else{
          commit('LOGIN_USER_INFO', {})
          commit('LOGIN_USER', '')
          removeToken()
        }
      })
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};